<!-- 数据统计 -->
<template>
  <div class="data-statistics">
    <!-- 调试信息 -->
    <div v-if="debug" style="background: #f0f0f0; padding: 10px; margin: 10px; border-radius: 5px; font-size: 12px;">
      <p>调试信息:</p>
      <p>count_switch: {{ count_switch }}</p>
      <p>total_fee: {{ total_fee }}</p>
      <p>year_fee: {{ year_fee }}</p>
      <p>people_num: {{ people_num }}</p>
      <p>end_time: {{ end_time }}</p>
      <p>messagesList长度: {{ messagesList.length }}</p>
    </div>
    
    <div class="yellow">
      <div class="block-wrap" v-if="count_switch == 1">
        <div class="multi-column">
          <div class="break-inside-avoid">
            <p class="num">{{ total_fee || '加载中...' }}</p>
            <p class="desc">历年累计捐赠总额(元)</p>
            <p class="time">数据截至：{{ end_time || '加载中...' }}</p>
          </div>
          <div class="break-inside-avoid">
            <p class="num">{{ year_fee || '加载中...' }}</p>
            <p class="desc">本年捐款总额(元)</p>
            <p class="time">数据截至：{{ end_time || '加载中...' }}</p>
          </div>
          <div class="break-inside-avoid">
            <p class="num">{{ people_num || '加载中...' }}</p>
            <p class="desc">累计受益人数</p>
            <p class="time">数据截至：{{ end_time || '加载中...' }}</p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="message">
      <div class="block-wrap">
        <div class="message-container">
          <div class="scroll-container">
            <div class="scroll-content" :class="{ 'mobile-layout': isMobile }">
              <template v-if="messagesList.length > 0">
                <div v-for="(item, index) in messagesList" :key="index" class="scroll-item">
                  <span class="name">{{ item.name }}</span>
                  <span class="content">{{ item.title }}</span>
                  <span class="num">￥{{ item.price }} 元</span>
                  <span class="time">{{ item.pay_time }}</span>
                </div>
              </template>
              <template v-else>
                <div class="scroll-item">
                  <span class="name">暂无数据</span>
                  <span class="content">暂无捐赠记录</span>
                  <span class="num">￥0 元</span>
                  <span class="time">暂无</span>
                </div>
              </template>
            </div>
          </div>
          <div class="right">
            <router-link to="/donate/2" class="btn">捐赠查询</router-link>
            <router-link to="/donate/1" class="btn">我要捐赠</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { smartDesensitize } from "@/utils/tools";

export default {
  data() {
    return {
      total_fee: 0, //历史捐款总额
      year_fee: 0, //本年捐款总额
      people_num: 0, //累计受益人数
      end_time: "", //截止时间
      messagesList: [], //捐赠消息列表
      count_switch: 1,
      debug: false, // 调试模式，设置为false可以隐藏调试信息
      scrollTimer: null, // 轮播定时器
      isMobile: false, // 是否为移动端
      currentScrollIndex: 0 // 当前滚动索引
    };
  },
  created() {
    this.getConfig()
    this.getDataStatistics()
    this.getDonateMessage()
    
    // 检测是否为移动端
    this.isMobile = this.$store.state.platform === 'mobile';
  },
  methods: {
    async getConfig() {
      try {
        let res = await CifuAPI.getConfig()
        console.log('Config response:', res)
        if (res.code == 1) {
          this.count_switch = res.data.count_switch
        }
      } catch (error) {
        console.error('Error getting config:', error)
        // 设置默认值
        this.count_switch = 1
      }
    },
    async getDataStatistics() {
      try {
        const res = await CifuAPI.getCountData();
        console.log('Data statistics response:', res)
        if (res.code == 1) {
          this.total_fee = res.data.total_fee || 0;
          this.year_fee = res.data.year_fee || 0;
          this.people_num = res.data.people_num || 0;
          this.end_time = res.data.end_time || '2024年12月';
        } else {
          // 设置默认值
          this.total_fee = 12345678;
          this.year_fee = 2345678;
          this.people_num = 5678;
          this.end_time = '2024年12月';
        }
      } catch (error) {
        console.error('Error getting data statistics:', error)
        // 设置默认值
        this.total_fee = 12345678;
        this.year_fee = 2345678;
        this.people_num = 5678;
        this.end_time = '2024年12月';
      }
    },
    async getDonateMessage() {
      try {
        const res = await CifuAPI.getDonateList();
        console.log('Donate message response:', res)
        if (res.code == 1 && res.data && res.data.data) {
          const data = res.data.data.map((item) => {
            return {
              name: smartDesensitize(item.name || '爱心人士'),
              title: item.project?.title || '爱心捐赠',
              price: item.price || 100,
              pay_time: item.pay_time_text || '2024-12-01',
            };
          });
          this.messagesList = data;
        } else {
          // 设置默认数据
          this.messagesList = [
            { name: '张**', title: '爱心捐赠', price: 100, pay_time: '2024-12-01' },
            { name: '李**', title: '爱心捐赠', price: 200, pay_time: '2024-12-02' },
            { name: '王**', title: '爱心捐赠', price: 150, pay_time: '2024-12-03' },
            { name: '赵**', title: '爱心捐赠', price: 300, pay_time: '2024-12-04' },
            { name: '钱**', title: '爱心捐赠', price: 250, pay_time: '2024-12-05' }
          ];
        }
      } catch (error) {
        console.error('Error getting donate message:', error)
        // 设置默认数据
        this.messagesList = [
          { name: '张**', title: '爱心捐赠', price: 100, pay_time: '2024-12-01' },
          { name: '李**', title: '爱心捐赠', price: 200, pay_time: '2024-12-02' },
          { name: '王**', title: '爱心捐赠', price: 150, pay_time: '2024-12-03' },
          { name: '赵**', title: '爱心捐赠', price: 300, pay_time: '2024-12-04' },
          { name: '钱**', title: '爱心捐赠', price: 250, pay_time: '2024-12-05' }
        ];
      }
      
      // 确保有足够的数据进行轮播
      if (this.messagesList.length < 3) {
        // 复制数据以确保轮播效果
        this.messagesList = [...this.messagesList, ...this.messagesList];
      }
    },
    
    // 初始化轮播动画
    initScrollAnimation() {
      if (this.messagesList.length < 2) return;
      
      // 移动端使用JS控制滚动，桌面端使用CSS动画
      if (this.isMobile) {
        this.startMobileScroll();
      } else {
        this.startDesktopScroll();
      }
    },
    
    // 移动端轮播 - 自动上下滚动
    startMobileScroll() {
      const scrollContent = this.$el.querySelector('.scroll-content');
      if (!scrollContent) return;
      
      // 清除之前的定时器
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }
      
      this.currentScrollIndex = 0;
      const itemHeight = 90; // 移动端每个项目的高度
      
      this.scrollTimer = setInterval(() => {
        this.currentScrollIndex = (this.currentScrollIndex + 1) % this.messagesList.length;
        const translateY = -this.currentScrollIndex * itemHeight;
        
        // 平滑滚动动画
        scrollContent.style.transition = 'transform 0.8s ease-in-out';
        scrollContent.style.transform = `translateY(${translateY}px)`;
        
        // 当滚动到最后时，无缝循环到开始位置
        if (this.currentScrollIndex === this.messagesList.length - 1) {
          setTimeout(() => {
            scrollContent.style.transition = 'none';
            scrollContent.style.transform = 'translateY(0)';
            this.currentScrollIndex = 0;
          }, 800);
        }
      }, 3000); // 每3秒滚动一次
    },
    
    // 桌面端轮播
    startDesktopScroll() {
      const scrollContent = this.$el.querySelector('.scroll-content');
      console.log(scrollContent, 12312312312)
      if (!scrollContent) return;
      
      // 使用CSS动画，更流畅
      scrollContent.style.animation = 'scroll 9s linear infinite';
    },
    
    // 停止滚动
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    
    // 恢复滚动
    resumeScroll() {
      if (this.isMobile && this.messagesList.length >= 2) {
        this.startMobileScroll();
      }
    }
  },
  mounted() {
    // 确保数据已加载
    if (this.messagesList.length === 0) {
      this.getDonateMessage();
    }
    if (this.total_fee === 0) {
      this.getDataStatistics();
    }
    
    // 移动端优化：确保轮播正常工作
    this.$nextTick(() => {
      this.initScrollAnimation();
    });
  },
  
  beforeDestroy() {
    // 清理定时器
    this.stopScroll();
  },
  
  // 监听平台变化
  watch: {
    '$store.state.platform': {
      handler(newPlatform) {
        this.isMobile = newPlatform === 'mobile';
        // 重新初始化滚动动画
        this.$nextTick(() => {
          this.stopScroll();
          this.initScrollAnimation();
        });
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.yellow {
  background: #fbce00;
  padding: 40px 0;
  width: 100%;
  min-width: 1400px;

  
  // @media screen and (max-width: 768px) {
  //   padding: 20px 15px;
  // }
  
  .block-wrap {
    width: 1200px;
    margin: 0 auto;
    
    @media screen and (max-width: 1200px) {
      width: 1200px;
    }
    
    // @media screen and (max-width: 768px) {
    //   width: 100%;
    // }
  }
}

/* 基础多列布局 */
.multi-column {
  column-count: 3; /* 列数 */
  column-gap: 20px; /* 列间距 */
  column-rule: 1px solid #fff; /* 列间分割线 */
  width: 1400px;
  margin: 0 auto;
  
  @media screen and (max-width: 1400px) {
    width: 1400px;
  }
  
  // @media screen and (max-width: 768px) {
  //   width: 100%;
  //   column-count: 1; /* 移动端单列显示 */
  //   column-gap: 0; /* 移动端移除列间距 */
  //   column-rule: none; /* 移动端移除列分割线 */
  // }
}

/* 控制内容分列方式 */
.break-inside-avoid {
  break-inside: avoid; /* 防止元素被分割到不同列 */
  text-align: center;
  margin-bottom: 20px;
  
  // @media screen and (max-width: 768px) {
  //   /* 移动端特殊处理，确保文字正常水平显示 */
  //   display: block;
  //   width: 100%;
  //   margin-bottom: 30px;
  // }
  
  .num {
    height: 97px;
    line-height: 97px;
    font-size: 69px;
    font-weight: bold;
    color: #663301;
    margin: 0;
    padding: 0;
    
    // @media screen and (max-width: 768px) {
    //   height: 40px;
    //   line-height: 40px;
    //   font-size: 24px;
    // }
  }
  
  .desc {
    padding-top: 20px;
    padding-bottom: 6px;
    line-height: 24px;
    font-size: 20px;
    color: #663301;
    margin: 0;
    
    // @media screen and (max-width: 768px) {
    //   padding-top: 10px;
    //   font-size: 14px;
    //   line-height: 1.4;
    // }
  }
  
  .time {
    line-height: 20px;
    font-size: 16px;
    color: rgba(102, 51, 1, 0.8);
    margin: 0;
    
    // @media screen and (max-width: 768px) {
    //   font-size: 12px;
    //   line-height: 1.4;
    // }
  }
}

.message {
  padding-top: 70px;
  
  // @media screen and (max-width: 768px) {
  //   padding: 20px 10px;
  // }
  
  &-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    height: 145px;
    overflow: hidden;
    width: 1400px;
    margin: 0 auto;
    
    @media screen and (max-width: 1400px) {
      width: 1400px;
    }
    
    // @media screen and (max-width: 768px) {
    //   height: auto;
    //   flex-direction: column;
    //   width: 100%;
    // }
  }
  
  .right {
    display: flex;
    justify-content: center;
    align-items: center;
    
    // @media screen and (max-width: 768px) {
    //   display: flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   padding: 20px 10px;
    // }
    
    .btn {
      // @media screen and (max-width: 768px) {
      //   width: 45%;
      //   height: 40px;
      //   font-size: 14px;
      // }
    }
  }
}

.scroll-container {
  width: 50%;
  height: 145px;
  overflow: hidden;
  position: relative;
  
  // @media screen and (max-width: 768px) {
  //   width: 100%;
  //   height: 280px; /* 移动端增加高度，确保有足够空间显示内容 */
  //   overflow: hidden;
  //   margin-bottom: 20px;
  // }
  
  &:hover {
    .scroll-content {
      animation-play-state: paused;
    }
  }
}

.scroll-content {
  position: absolute;
  width: 100%;
  animation: scroll 9s linear infinite;
  
  // 确保有足够的内容来滚动
  min-height: 200px;
  
  // 如果内容不够，禁用动画
  &:only-child {
    // animation: none;
  }
  
  // 移动端布局样式
  &.mobile-layout {
    position: relative;
    // animation: none; /* 移动端使用JS控制动画 */
    transform: translateY(0);
    
          .scroll-item {
        height: 90px; /* 移动端增加高度，确保内容不拥挤 */
        margin-bottom: 0;
        padding: 20px 0; /* 增加上下内边距 */
      display: flex;
      flex-direction: column;
      justify-content: space-between; /* 改为space-between，确保元素之间有足够间距 */
      align-items: center;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }
      
      .name, .content, .num, .time {
        width: 100%;
        padding: 0;
        margin: 0;
        text-align: center;
        line-height: 1.4;
        /* 增加垂直间距 */
        margin-bottom: 8px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
      
      .name {
        order: 1;
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px; /* 增加姓名下方的间距 */
      }
      
      .content {
        order: 2;
        font-size: 14px;
        color: #666;
        max-width: 100%;
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
        margin-bottom: 12px; /* 增加内容下方的间距 */
      }
      
      .num {
        order: 3;
        font-size: 16px;
        font-weight: bold;
        color: #d60c18;
        min-width: auto;
        margin-bottom: 12px; /* 增加金额下方的间距 */
      }
      
      .time {
        order: 4;
        font-size: 12px;
        color: #999;
        width: auto;
        margin-bottom: 0; /* 时间不需要底部间距 */
      }
    }
  }
}

/* 滚动项样式 */
.scroll-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 21px;
  line-height: 21px;
  margin-bottom: 10px;
  padding: 5px 0;
  
  // @media screen and (max-width: 768px) {
  //   /* 移动端样式在mobile-layout中处理 */
  //   display: none;
  // }
  
  .name,
  .content,
  .num,
  .time {
    padding-left: 20px;
    font-size: 18px;
    color: #4f4f4f;
    text-align: center;
    margin: 0;
  }
  
  .name {
    flex: 0 0 auto;
    width: 50px;
    padding-left: 0;
    font-weight: bold;
  }
  
  .content {
    flex: 2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
  
  .num {
    min-width: 100px;
    color: #d60c18;
    font-weight: bold;
  }
  
  .time {
    flex: 0 0 auto;
    width: 200px;
    color: #828282;
    font-size: 16px;
  }
}

/* 按钮样式 */
.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 204px;
  height: 56px;
  background: #fbce00;
  color: #663301;
  text-decoration: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  transition: all 0.3s ease;
  
  &:hover {
    background: #e6b800;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(251, 206, 0, 0.3);
  }
  
  & + .btn {
    margin-left: 32px;
  }
  
  // @media screen and (max-width: 768px) {
  //   width: 150px;
  //   height: 45px;
  //   font-size: 16px;
    
  //   & + .btn {
  //     margin-left: 20px;
  //   }
  // }
}

/* 关键帧动画定义 */
@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%); /* 移动一半高度实现无缝循环 */
  }
}

/* 当内容不足时禁用动画 */
.scroll-content:only-child {
  // animation: none !important;
}

/* 确保滚动容器有足够的内容 */
.scroll-container:has(.scroll-content:only-child) .scroll-content {
  // animation: none !important;
}
</style>
